// extracted by mini-css-extract-plugin
module.exports = {"root":"SeoBlock_root__qnt74","title":"SeoBlock_title__3B9i4","meta":"SeoBlock_meta__q8hQw","intro":"SeoBlock_intro__XNsof","lastUpdated":"SeoBlock_lastUpdated__C6FKB"};